import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="py-24 flex flex-col items-center text-center">
      <div className="text-6xl font-bold text-brand-500">404</div>
      <h1 className="mt-3 text-xl font-semibold text-ink">Page not found</h1>
      <p className="mt-2 text-sm text-ink-soft max-w-md">
        This URL isn't part of the panel. It might have moved, or the link is wrong.
      </p>
      <Link to="/" className="mt-6">
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
